var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("a", { attrs: { href: _vm.item.details.link } }, [
    _c("img", {
      staticClass: "cart-item__image",
      attrs: { src: _vm.item.details.image, alt: "" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "cart-item__body" }, [
      _c("h6", { staticClass: "cart-item__name" }, [
        _vm._v("\n      " + _vm._s(_vm.item.details.product) + "\n    "),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "cart-item__price" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.item.quantity) +
            " x " +
            _vm._s(_vm.item.details.price) +
            "       "
        ),
        _vm.item.details.sale_price
          ? _c("del", [_vm._v(_vm._s(_vm.item.details.sale_price))])
          : _vm._e(),
        _vm._v(
          " = " + _vm._s(_vm.item.quantity * _vm.item.details.price) + "\n    "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/CartItem.vue